var styleDataHash = "179fc3ae";
const injectCss = () => {
  var css = `.QLVao{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .QLVao{border:0}[dir=ltr] .QLVao{left:0}[dir=rtl] .QLVao{right:0}.lPYYZ{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .lPYYZ,[dir=rtl] .lPYYZ{left:0;right:0}.YduhU{height:0;position:relative}[dir] .YduhU{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){.YduhU{min-width:auto}}}@container (width < 640px){.YduhU{min-width:auto}}.d2Qez{bottom:0;height:100%;position:absolute;top:0;width:100%;z-index:1}[dir] .d2Qez{cursor:move}.d2Qez~*>*{pointer-events:none}.KxXX4{height:0;overflow:hidden;visibility:hidden;width:0}.ERKaA,.KxXX4{position:absolute}.ERKaA{align-items:center;color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;top:0;width:100%;z-index:1}[dir] .ERKaA{background:rgba(0,0,0,.5);text-align:center}[dir=ltr] .ERKaA{right:0}[dir=rtl] .ERKaA{left:0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var default_video_styles_default = {
  "video_player": "QLVao",
  "videoOverlay": "lPYYZ",
  "video_container": "YduhU",
  "video_overlay": "d2Qez",
  "hide_duration": "KxXX4",
  "error": "ERKaA"
};
export {
  default_video_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-video-styles-scss.js.map
